export default __webpack_public_path__ + "static/media/1169.e39d464a.png";